import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Text, IconButton, Label, LoadingTable, Autocomplete } from '@artprov/design-system'
import CargarNominaButton from './components/CargarNominaButton'
import AbrirExcelButton from './components/AbrirExcelButton'
import { useAlert } from '@common/components/alert/use-alert.hook'
import {
  getDeclaraciones as getDeclaracionesApi,
  getIdDeclaracionBorrador,
  getDeclaracionPeriodo,
  bajaDeclaracion,
  validatePeriodoFiscal as validatePeriodoFiscalApi,
  desestimarNominaDeclaracion as desestimarNominaDeclaracionApi,
  getMotivoRechazoDeclaracion as getMotivoRechazoDeclaracionApi,
  verificarRectificativa as verificarRectificativaApi,
  getReporteDdjjExtraSuss as getReporteDdjjExtraSussApi,
  getContrato as getDataContratoApi,
  getContratos as getContratosApi,
  getUserContrato as getUserContratoApi,
  verificarTerminosCondiciones as verificarTerminosCondicionesApi,
  aceptarTerminosCondiciones as aceptarTerminosCondicionesApi,
  getTerminosCondiciones,
} from '../../services'
// import { httpInstance } from '../../services/backend.service'
import IndicatorOs from './components/IndicatorOs'
import { declaracionesAdapter } from '../../services/adapter/declaraciones.adapter'
import { columnasNomina } from './columnasNomina'
import ModalPeriodo from './ModalPeriodo'
import ModalBorradorExistente from './ModalBorradorExistente'
import ModalDesestimarNomina from './components/ModalDesestimarNomina'
import ModalMotivoRechazo from './components/ModalMotivoRechazo'
import ModalRectificativa from './ModalRectificativa'
import { adaptarPeriodo } from '../../common/components/InputMonthYear/date.utils'
import { useContratoStore } from '../../common/store/contrato.store'
// import { useAuthStore } from '../../common/store/auth.store'
import ModalTerminosCondiciones from '../productor/ModalTerminosCondiciones'

export default function Inicio() {
  // const { contratoId, setContratoId, clearContratoId } = useAuthStore()
  const navigate = useNavigate()
  const alert = useAlert()
  const [declaraciones, setDeclaraciones] = useState([])
  const [openModalPeriodo, setOpenModalPeriodo] = useState(false)
  const [hintsInputMonth, setHintsInputMonth] = useState([])
  const [selectedRow] = useState([])
  const [openModalBorradorExistente, setOpenModalBorradorExistente] = useState(false)
  const [selectedPeriodo, setSelectedPeriodo] = useState(null) // Added for broader use

  // Estados para control de debug del botón Excel
  const [showExcelButton, setShowExcelButton] = useState(false)
  const [excelPath, setExcelPath] = useState(
    '\\\\artprov.com.ar\\storage\\Storage_Data\\Suscripciones\\Cotizaciones\\DESA\\2026\\05\\21\\134003\\2026 5 21 CLINICA ARGENTINA S R 1.xlsm'
  )

  const [openModalDesestimarNomina, setOpenModalDesestimarNomina] = useState(false)
  const [onAcceptModalModalDesestimarNomina, setOnAcceptModalModalDesestimarNomina] = useState(false)

  const [openModalMotivoRechazo, setOpenModalMotivoRechazo] = useState(false)
  const [openModalTerminosCondiciones, setOpenModalTerminosCondiciones] = useState(false)
  const [contentTerminosCondiciones, setContentTerminosCondiciones] = useState('')

  const [openModalModalRectificativa, setOpenModalModalRectificativa] = useState(false)
  const [showAlertRectificativa, setShowAlertRectificativa] = useState(false)

  const [dataMotivoRechazo, setDataMotivoRechazo] = useState({})

  const {
    razonSocial,
    cuit,
    contratoId,
    clearContrato,
    setContratoData,
    contratos,
    setContratos,
    contratoSelected,
    setContratoSelected,
    isAdmin,
    setIsAdmin,
  } = useContratoStore()
  // const { isAdmin, setAdmin } = useAuthStore()
  const [reload, setReload] = useState(false)
  const [loading, setLoading] = useState(true)

  const [emptyErrorTable] = useState({
    icon: 'info',
    title: 'No hay declaraciones disponibles',
    description: 'Actualmente no hay declaraciones para mostrar.',
    iconStyles: 'text-warning-20',
    titleStyles: 'text-primary-10',
    descriptionStyles: 'w-96 text-balance',
  })
  const [adminErrorTable] = useState({
    icon: 'info',
    title: 'Todavía no hay información para mostrar',
    description: 'Seleccioná un CUIT | Razón social para poder visualizar los datos disponibles.',
    iconStyles: 'text-warning-20',
    titleStyles: 'text-primary-10',
    descriptionStyles: 'w-96 text-balance',
  })
  const estadosDeclaracion = [
    {
      nombre: 'no_procesado',
      nombreFe: 'En proceso',
      color: 'yellow',
      icon: 'close',
    },
    {
      nombre: 'en_proceso',
      nombreFe: 'En proceso',
      color: 'yellow',
      icon: 'close',
    },
    {
      nombre: 'procesado',
      nombreFe: 'Aceptado',
      color: 'green',
      icon: 'download',
    },
    {
      nombre: 'rechazado',
      nombreFe: 'Rechazado',
      color: 'red',
      icon: 'visibility',
    },
    {
      nombre: 'rechazado_-_simulacion',
      nombreFe: 'Rechazado',
      color: 'red',
      icon: 'visibility',
    },
    { nombre: 'borrador', nombreFe: 'Borrador', color: 'gray', icon: 'edit' },
    {
      nombre: 'aceptada',
      nombreFe: 'Aceptada',
      color: 'green',
      icon: 'download',
    },
  ]

  async function getDeclaraciones() {
    return await getDeclaracionesApi()
  }

  async function getContratos() {
    return await getContratosApi()
  }

  const [hasInitialized, setHasInitialized] = useState(false)

  // Exponer controles de debug en window para pruebas desde consola
  useEffect(() => {
    window.excelDebug = {
      show: () => {
        setShowExcelButton(true)
        console.log('✅ Botón Excel visible')
      },
      hide: () => {
        setShowExcelButton(false)
        console.log('❌ Botón Excel oculto')
      },
      setPath: (path) => {
        setExcelPath(path)
        console.log('📁 Ruta actualizada:', path)
      },
      getPath: () => {
        console.log('📁 Ruta actual:', excelPath)
        return excelPath
      },
      help: () => {
        console.log(`
🔧 Comandos disponibles para debug del botón Excel:

  window.excelDebug.show()           - Mostrar el botón Excel
  window.excelDebug.hide()           - Ocultar el botón Excel
  window.excelDebug.setPath(ruta)    - Cambiar la ruta UNC del archivo
  window.excelDebug.getPath()        - Ver la ruta actual
  window.excelDebug.help()           - Mostrar esta ayuda

Ejemplo de uso:
  window.excelDebug.show()
  window.excelDebug.setPath('\\\\\\\\servidor\\\\carpeta\\\\archivo.xlsm')
        `)
      },
    }
    // console.log('🔧 Debug Excel disponible. Ejecuta window.excelDebug.help() para ver comandos')
  }, [excelPath])

  useEffect(() => {
    setLoading(true)
    const init = async () => {
      if (!hasInitialized) {
        await configContratoUser()
        // await verificarTerminosCondiciones()
        setHasInitialized(true)
      }
    }

    init()
  }, [reload])

  const loadGeneralData = async () => {
    setLoading(true)
    try {
      const declaraciones = await getDeclaraciones()
      const declaracionesAdapted = declaracionesAdaptedToDom(declaracionesAdapter(declaraciones))
      setDeclaraciones(declaracionesAdapted || [])
      handleShowAlertNominaEstadoBorrador(declaraciones)
    } catch (error) {
      console.error('Error al cargar las declaraciones', error)
      setDeclaraciones([])
      alert.show({
        description: 'No pudimos cargar tus declaraciones. Por favor, intentá nuevamente en unos minutos.',
        variant: 'warning',
        autoDismiss: false,
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    // httpInstance.defaults.headers.common['X-Contrato'] = contratoId
    // El header X-Contrato se inyecta automáticamente desde el store
    // mediante el interceptor de backend.service.js.
    loadGeneralData()
  }, [contratoId])

  useEffect(() => {
    if (contratoSelected) {
      handleChangeidcontrato(contratoSelected?.id)
    }
  }, [contratoSelected])

  const configContratoUser = async () => {
    // if (httpInstance.defaults.headers.common['X-Contrato']) {
    //   return
    // }
    // Si ya hay un contrato activo (persistido en el store), no reconfiguramos.
    if (useContratoStore.getState().contratoId) {
      return
    }

    try {
      let contratos = await getUserContratoApi()
      // El servicio getUserContrato normaliza el flag `admin === 'S'` a `isAdmin`.
      if (contratos?.isAdmin) {
        setIsAdmin(true)
        let todosContratos = await getContratos()
        setContratos(todosContratos?.data?.data || [])
        setLoading(false)
      } else {
        // If not admin, use the single contract from the response
        let contrato = contratos?.data[0]?.contrato || []
        // The X-Contrato header will be set automatically by the interceptor
        await setDatosContrato(contrato)
        await verificarTerminosCondiciones()
        await loadGeneralData()
      }
    } catch (error) {
      console.error('Error al configurar el contrato del usuario', error)
      setLoading(false)
      alert.show({
        description: 'No pudimos cargar tus datos. Por favor, intentá nuevamente en unos minutos.',
        variant: 'warning',
        autoDismiss: false,
      })
    }
  }

  const verificarTerminosCondiciones = async () => {
    try {
      let response = await verificarTerminosCondicionesApi()
      if (response?.debeAceptar) {
        setContentTerminosCondiciones(response?.data || '')
        setOpenModalTerminosCondiciones(true)
      }
    } catch (error) {
      // Un fallo al consultar los T&C no debe impedir ver las declaraciones ya presentadas.
      console.error('Error al verificar términos y condiciones', error)
    }
  }

  const aceptarTerminosCondiciones = async () => {
    try {
      await aceptarTerminosCondicionesApi()
      setOpenModalTerminosCondiciones(false)
    } catch (error) {
      alert.show({
        description: `Ha ocurrido un error`,
        variant: 'warning',
        autoDismiss: false,
      })
    }
  }

  const setDatosContrato = async (id) => {
    if (id) {
      let contratoData = await getDataContratoApi({ id })
      const razonSocial = contratoData?.data?.data?.HM_NOMBRE
      const cuit = contratoData?.data?.data?.HM_CUIT

      // Only update store if values are different
      if (razonSocial !== useContratoStore.getState().razonSocial || cuit !== useContratoStore.getState().cuit) {
        setContratoData({
          razonSocial: razonSocial,
          cuit: cuit,
          contratoId: id,
        })
      }
    }
  }

  const handleChangeidcontrato = async (id) => {
    // The X-Contrato header will be set automatically by the interceptor based on the store
    await setDatosContrato(id)
    setReload(!reload)
  }

  const fetchIdBorrador = async () => {
    try {
      // const res = await getIdDeclaracionBorrador({ contrato, usuario })
      const res = await getIdDeclaracionBorrador({ contrato: null, usuario: null })
      return Number(res?.data?.data ?? res?.data ?? -1)
    } catch (error) {
      return -1
    }
  }

  const fetchDeclaracionPeriodo = async (idNomina) => {
    try {
      const res = await getDeclaracionPeriodo({ idNomina: idNomina })
      return Number(res?.data?.data ?? res?.data ?? -1)
    } catch (error) {
      return -1
    }
  }

  const handleShowAlertNominaEstadoBorrador = (declaraciones) => {
    const declaracionesData = declaraciones?.data?.data
    let hasDeclaracionBorrador = false
    hasDeclaracionBorrador = declaracionesData?.some((element) => {
      return element.ESTADO == 'Borrador'
    })
    if (hasDeclaracionBorrador) {
      alert.show({
        description: `Tenés una nómina en borrador que aún no se completó. Revisala para finalizar la carga.`,
        variant: 'warning',
        autoDismiss: false,
      })
    }
  }

  const handlePeriodoCargaNomina = async () => {
    const idBorrador = await fetchIdBorrador(null, null)
    // const idBorrador = await fetchIdBorrador()
    if (idBorrador > 0) {
      setOpenModalBorradorExistente(true)
    } else {
      setOpenModalPeriodo(true)
    }
  }

  const handleOnAcceptModalPeriodo = async (periodo) => {
    try {
      const validatePeriodo = await validatePeriodoNomina(periodo)
      if (!validatePeriodo) {
        return false
      }
      setSelectedPeriodo(periodo) // Store the validated period in state
      const responseVerificarRectificativa = await verificarRectificativa(periodo)
      if (responseVerificarRectificativa?.EXISTE == 'N') {
        return true
      } else {
        setShowAlertRectificativa(true)
      }
    } catch (error) {
      return false
    }
  }
  const validatePeriodoNomina = async (periodo) => {
    //llamado a servicio
    const formattedPeriodo = periodo?.replace('/', '-')
    try {
      const response = await validatePeriodoFiscalApi({ periodo: formattedPeriodo })
      if (response.status == 200) {
        return true
      }
    } catch (error) {
      if (['BusinessValidation', 'InputValidation'].includes(error?.response?.data?.type)) {
        const message = error?.response?.data?.message
        setHintsInputMonth([{ variant: 'error', text: message }])
        return
      }
    }
  }

  const verificarRectificativa = async (periodo) => {
    const formattedPeriodo = periodo?.replace('/', '-')
    try {
      const response = await verificarRectificativaApi({ periodo: formattedPeriodo })
      if (response.status == 200) {
        return response.data?.data
      }
    } catch (error) {
      alert.show({
        description: `Ha ocurrido un error`,
        variant: 'warning',
        autoDismiss: true,
      })
    }
  }

  const onAcceptModalModalRectificativa = async () => {
    try {
      // await bajaDeclaracion({ idNomina: idNominaRectificativa })
      handleRedirectToCargarNomina(selectedPeriodo) // Use selectedPeriodo from state
    } catch (error) {
      console.error('Error al dar de baja la declaración rectificativa', error) // Added error handling
    }
  }

  function getHtmlEstadoCircle({ color = 'green' }) {
    const colorMap = {
      green: 'bg-success-30',
      yellow: 'bg-warning-20',
      red: 'bg-error-30',
      gray: 'bg-gray-300',
    }

    return <div className={`rounded-full size-2 ${colorMap[color]}`} />
  }

  function declaracionesAdaptedToDom(declaraciones) {
    const declaracionesAdaptedToDom = declaraciones?.rows?.map((item, i) => {
      const estadoDeclaracion = estadosDeclaracion.find((est) => {
        return est.nombre == item.estado
      })

      let buttonActionDeclaracion = ''
      if (item.estado_cabecera != 5) {
        buttonActionDeclaracion = (
          <IconButton
            key={i + item.nro}
            icon={estadoDeclaracion?.icon || item.estado}
            className="gap-0 m-0 p-0 w-full "
            onClick={async () => {
              if (item.estado_cabecera === 1) {
                navigate(`/cargar-nomina/${item.periodo?.replace(/^(\d{4})(\d{2})$/, '$1-$2')}/${item.idNomina}`)
              }
              if (item.estado_cabecera === 2) {
                desestimarDeclaracion(item.idNomina, item.periodo)
              }

              if (item.estado_cabecera === 3 || item.estado_cabecera === 7) {
                showMotivoRechazo(item.idNomina, item.periodo)
              }

              if (item.estado_cabecera === 6) {
                handleButtonDescargarComprobanteNoSuss(item.idNomina)
              }
            }}
          />
        )
      }

      const labelEstadoDeclaracion = (
        <div className="flex items-center gap-2">
          {getHtmlEstadoCircle({ color: estadoDeclaracion?.color })}
          <Label
            label={estadoDeclaracion?.nombreFe || item.estado}
            key={`label-${i}-${item.nro}`}
            className="gap-0 m-0 p-0 w-full text-tertiary-10 "
          />
        </div>
      )

      return {
        ...item,
        estado: labelEstadoDeclaracion,
        acciones: buttonActionDeclaracion,
      }
    })

    return declaracionesAdaptedToDom
  }
  const showMotivoRechazo = async (idNomina, periodo) => {
    try {
      const response = await getMotivoRechazoDeclaracionApi({ id: idNomina })
      const FECHA_RECHAZO = response.data?.data?.FECHA_RECHAZO || ''
      const MOTIVO_RECHAZO = response.data?.data?.MOTIVO_RECHAZO || ''
      setDataMotivoRechazo({ fecha_rechazo: FECHA_RECHAZO, motivo_rechazo: MOTIVO_RECHAZO, periodo })
      setOpenModalMotivoRechazo(true)
    } catch (error) {
      alert.show({
        description: `Ha ocurrido un error`,
        variant: 'warning',
        autoDismiss: true,
      })
    }
  }
  const desestimarDeclaracion = (id, periodo) => {
    setOpenModalDesestimarNomina(true)
    setOnAcceptModalModalDesestimarNomina(() => () => handleDesestimarDeclaracion(id, periodo))
  }

  const onCloseModalModalDesestimarNomina = () => {
    setOpenModalDesestimarNomina(false)
  }

  const handleDesestimarDeclaracion = async (id, periodo) => {
    try {
      await desestimarNominaDeclaracionApi({ id })
      setOpenModalDesestimarNomina(false)
      alert.show({
        description: `La declaracion del período ${periodo?.replace(/^(\d{4})(\d{2})$/, '$1-$2')} fue desestimada con éxito.`,
        variant: 'success',
        autoDismiss: true,
      })
      setReload(true)
      loadGeneralData()
    } catch (error) {
      setOpenModalDesestimarNomina(false)
      if (error) {
        alert.show({
          description: `No se puedo desestimar la declaración del período ${periodo?.replace(/^(\d{4})(\d{2})$/, '$1-$2')}. Por favor, intenta nuevamente`,
          variant: 'warning',
          autoDismiss: true,
        })
      }
    }
  }

  const handleRedirectToCargarNomina = (periodo) => {
    const formattedPeriodo = periodo?.replace('/', '-')
    navigate(`/cargar-nomina/${formattedPeriodo}/carga`)
  }

  const handleButtonDescargarComprobanteNoSuss = async (idNomina) => {
    try {
      const repsonse = await getReporteDdjjExtraSussApi({ id: idNomina })
      window.open(repsonse?.data?.data)
    } catch (error) {
      let description = 'Ha ocurrido un error'
      if (error.response?.data?.type == 'InputValidation') {
        alert.show({
          description: error.response?.data?.message[0],
          variant: 'warning',
          autoDismiss: true,
        })
        return
      }

      alert.show({
        description: description,
        variant: 'warning',
        autoDismiss: true,
      })
    }
  }

  const onCloseModalPeriodo = () => {
    setOpenModalPeriodo(false)
    setShowAlertRectificativa(false)
  }

  const onCancelModalBorradorExistente = async () => {
    const idBorrador = await fetchIdBorrador()
    const periodo = await fetchDeclaracionPeriodo(idBorrador)
    setOpenModalBorradorExistente(false)
    setOpenModalPeriodo(false)
    const periodoAdaptado = adaptarPeriodo(periodo)
    navigate(`/cargar-nomina/${periodoAdaptado}/${idBorrador}`)
  }

  const onCloseModalBorradorExistente = async () => {
    setOpenModalBorradorExistente(false)
    setOpenModalPeriodo(false)
  }

  const onAcceptModalBorradorExistente = async () => {
    setOpenModalBorradorExistente(false)

    try {
      const idBorrador = await fetchIdBorrador(285998, 'FNOVELLO')
      const res = await bajaDeclaracion({ idNomina: idBorrador, usuario: 'FNOVELLO' })

      if (res?.status === 200) {
        setOpenModalPeriodo(true)
      } else {
        console.error('Error al dar de baja la declaración en borrador')
      }
    } catch (error) {
      console.error('Error al dar de baja la declaración en borrador', error)
    }
  }

  const handleButtonDescargarTerminosCondiciones = async () => {
    try {
      await getTerminosCondiciones()
    } catch (error) {
      alert.show({
        description: 'Ha ocurrido un error al descargar el archivo. Por favor, intenta nuevamente.',
        variant: 'warning',
        autoDismiss: true,
      })
    }
  }

  return (
    <div className="w-full hidden sm:flex">
      <div className="w-full px-10 lg:px-24 pb-[62px]">
        <section className="pt-8 pb-5">
          <div className="flex justify-between items-center">
            <div>
              <Text variant="h6" className="text-primary-20">
                Presentación de nómina de personal extra SUSS
              </Text>
              <Text variant="body2" className="text-tertiary-20">
                Declaración Jurada de personal
              </Text>
            </div>
            {showExcelButton && excelPath && (
              <AbrirExcelButton uncPath={excelPath} label="Abrir planilla Excel" size="small" />
            )}
          </div>
        </section>
        {/* Mostrar IndicatorOs cuando NO es admin o no hay contratos, mostrar autocomplete cuando es admin y hay contratos */}
        {isAdmin && contratos.length > 0 ? (
          <div className="pb-5 relative flex w-full justify-between items-end ">
            {/* <div className="flex flex-col pl-6 py-3 border-l border-t border-b  border-r rounded-br-lg w-1/2"> */}
            <div className=" pl-6 py-3 border-l border-t border-b  border-r rounded-br-lg w-2/3">
              <Autocomplete
                label="Razón social | CUIT"
                placeholder="Buscar"
                // classNameContainer="w-3/4"
                classNameContainer="w-full pr-4"
                opciones={contratos.map((contrato) => {
                  return {
                    id: contrato.HC_CONTRATO || contrato.id,
                    descripcion: `${contrato.HM_NOMBRE} | ${contrato.HM_CUIT}`,
                  }
                })}
                searchValue={contratoSelected ? contratoSelected.descripcion : ''}
                setSelected={setContratoSelected}
                onClear={() => {
                  setDeclaraciones([])
                  clearContrato()
                  setLoading(false)
                }}
                isRequired={false}
                hints={[]}
              />
            </div>
            <div className="flex  justify-end items-end ">
              <CargarNominaButton onClick={handlePeriodoCargaNomina} disabled={isAdmin && !contratoId} />
            </div>
          </div>
        ) : (
          <div className="pb-5">
            <IndicatorOs razonSocial={razonSocial} cuit={cuit}>
              <div className="flex  justify-end items-end ">
                <CargarNominaButton onClick={handlePeriodoCargaNomina} disabled={isAdmin && !contratoId} />
              </div>
            </IndicatorOs>
          </div>
        )}
        <section className="flex flex-col gap-4 pb-4">
          {/* {'loading -' + JSON.stringify(loading) + '- admin - ' + JSON.stringify(isAdmin) + '- initalized - ' + JSON.stringify(hasInitialized) + '- reload - ' + JSON.stringify(reload) + '- contratos - ' + JSON.stringify(contratos.length) + '- contrato id - ' + contratoId} */}
          <LoadingTable
            sortable={true}
            columns={columnasNomina}
            selectable={false}
            uniqueKey="uuid"
            data={declaraciones}
            selected={selectedRow}
            emptyState={
              isAdmin && hasInitialized == true
                ? contratoSelected == undefined
                  ? adminErrorTable
                  : declaraciones.length == 0 && loading == false
                    ? emptyErrorTable
                    : null
                : loading == false && declaraciones.length == 0
                  ? emptyErrorTable
                  : null
            }
            isLoading={loading}
            loadingIcon="progress_activity"
            loadingText="Solicitud en proceso"
            loadingIconVariant="primary"
            textVariant="subtitle1"
            textClassName="text-primary-10"
          />
        </section>
        <ModalPeriodo
          openModal={openModalPeriodo}
          onCloseModal={onCloseModalPeriodo}
          showAlertRectificativa={showAlertRectificativa}
          titulo="Período fiscal"
          hintsInputMonth={hintsInputMonth}
          onAcceptModal={handleOnAcceptModalPeriodo}
          onRedirectToCargarNomina={handleRedirectToCargarNomina}
        />
        <ModalBorradorExistente
          openModal={openModalBorradorExistente}
          titulo="Tenés una nómina en Borrador"
          onCancelModal={onCancelModalBorradorExistente}
          onAcceptModal={onAcceptModalBorradorExistente}
          onCloseModal={onCloseModalBorradorExistente}
        />

        <ModalRectificativa
          openModal={openModalModalRectificativa}
          titulo="Este período ya fue cargado"
          onCancelModal={() => setOpenModalModalRectificativa(false)}
          onAcceptModal={onAcceptModalModalRectificativa}
          onCloseModal={() => setOpenModalModalRectificativa(false)}
        />

        <ModalDesestimarNomina
          openModal={openModalDesestimarNomina}
          icon="info"
          titulo="Desestimar una declaración"
          mensaje="Si la desestimas, se perderá la declaración cargada"
          onAcceptModal={onAcceptModalModalDesestimarNomina}
          onCloseModal={onCloseModalModalDesestimarNomina}
        ></ModalDesestimarNomina>

        <ModalMotivoRechazo
          openModal={openModalMotivoRechazo}
          motivoRechazo={dataMotivoRechazo}
          icon="info"
          titulo="Estás por desestimar una declaración"
          mensaje="¿Estás seguro que querés desestimar esta declaración?"
          onCloseModal={() => setOpenModalMotivoRechazo(false)}
        ></ModalMotivoRechazo>
        <ModalTerminosCondiciones
          openModal={openModalTerminosCondiciones}
          onCloseModal={() => {}}
          onAcceptModal={() => aceptarTerminosCondiciones()}
          titulo="Términos y Condiciones de Uso"
          content={contentTerminosCondiciones}
          onDownloadTerm={() => handleButtonDescargarTerminosCondiciones()}
        />
      </div>
    </div>
  )
}
